import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Container from '@material-ui/core/Container'
import './ApiDoc.css';
// ApiDoc___Components
import ApiDocIntro from './ApiDocIntro';
import ApiDocServicios from './ApiDocServicios';
import ApiDocPron from './ApiDocPron';
import ApiDocImg from './ApiDocImg';
// import ApiDocTrabajadores from './ApiDocTrabajadores';
import ApiDocProyectos from './ApiDocProyectos';
import ApiDocNoticias from './ApiDocNoticias';
import ApiDocEventos from './ApiDocEventos';
import ApiDocAlertas from './ApiDocAlertas';
import ApiDocHuracanes from './ApiDocHuracanes';
import { SwipeableDrawer, useMediaQuery } from '@material-ui/core';


const drawerWidth = 240;
let drawerTop = 120;
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    background: 'transparent',
    borderWidth: 0,
    // left: theme.spacing(0),
    top: drawerTop,
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  divider: {
    marginBottom: theme.spacing(5),
  },
}));

export default function ApiDoc(props) {
  const classes = useStyles();
  const [showApiDocIntroComponent, setShowApiDocIntroComponent] = useState(true);
  const [showApiDocServiciosComponent, setShowApiDocServiciosComponent] = useState(false);
  const [showApiDocPronComponent, setShowApiDocPronComponent] = useState(false);
  const [showApiDocImgComponent, setShowApiDocImgComponent] = useState(false);
  // const [showApiDocTrabajadoresComponent, setShowApiDocTrabajadoresComponent] = useState(false);
  const [showApiDocProyectosComponent, setShowApiDocProyectosComponent] = useState(false);
  const [showApiDocNoticiasComponent, setShowApiDocNoticiasComponent] = useState(false);
  const [showApiDocEventosComponent, setShowApiDocEventosComponent] = useState(false);
  const [showApiDocAlertasComponent, setShowApiDocAlertasComponent] = useState(false);
  const [showApiDocHuracanesComponent, setShowApiDocHuracanesComponent] = useState(false);

  const [openDrawer, setOpenDrawer] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 1);
    return () => {
      // cleanup
    }
  }, [])

  useEffect(() => {
    const header = document.getElementById('header');
    console.log('headerHeight', header.offsetHeight, header.clientHeight);
    return () => {
      // cleanup
    }
  })

  function setVisible(event, text) {
    setOpenDrawer(false);

    // window.scrollTo(0, 1);
    // scroll suavizado cada vez que cambi ...
    const anchor = (event.target.ownerDocument || document).querySelector('#root');
    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    switch (text) {
      case 'Servicios':
        setShowApiDocIntroComponent(false);
        setShowApiDocServiciosComponent(true);
        setShowApiDocPronComponent(false);
        setShowApiDocImgComponent(false);
        // setShowApiDocTrabajadoresComponent(false);
        setShowApiDocProyectosComponent(false);
        setShowApiDocNoticiasComponent(false);
        setShowApiDocEventosComponent(false);
        setShowApiDocAlertasComponent(false);
        setShowApiDocHuracanesComponent(false);
        break;
      case 'Pronósticos':
        setShowApiDocIntroComponent(false);
        setShowApiDocServiciosComponent(false);
        setShowApiDocPronComponent(true);
        setShowApiDocImgComponent(false);
        // setShowApiDocTrabajadoresComponent(false);
        setShowApiDocProyectosComponent(false);
        setShowApiDocNoticiasComponent(false);
        setShowApiDocEventosComponent(false);
        setShowApiDocAlertasComponent(false);
        setShowApiDocHuracanesComponent(false);
        break;
      case 'Imágenes':
        setShowApiDocIntroComponent(false);
        setShowApiDocServiciosComponent(false);
        setShowApiDocPronComponent(false);
        setShowApiDocImgComponent(true);
        // setShowApiDocTrabajadoresComponent(false);
        setShowApiDocProyectosComponent(false);
        setShowApiDocNoticiasComponent(false);
        setShowApiDocEventosComponent(false);
        setShowApiDocAlertasComponent(false);
        setShowApiDocHuracanesComponent(false);
        break;
      // case 'Trabajadores':
      //   setShowApiDocIntroComponent(false);
      //   setShowApiDocServiciosComponent(false);
      //   setShowApiDocPronComponent(false);
      //   setShowApiDocImgComponent(false);
      //   setShowApiDocTrabajadoresComponent(true);
      //   setShowApiDocProyectosComponent(false);
      //   setShowApiDocNoticiasComponent(false);
      //   setShowApiDocEventosComponent(false);
      //   setShowApiDocAlertasComponent(false);
      //   setShowApiDocHuracanesComponent(false);
      //   break;
      case 'Proyectos':
        setShowApiDocIntroComponent(false);
        setShowApiDocServiciosComponent(false);
        setShowApiDocPronComponent(false);
        setShowApiDocImgComponent(false);
        // setShowApiDocTrabajadoresComponent(false);
        setShowApiDocProyectosComponent(true);
        setShowApiDocNoticiasComponent(false);
        setShowApiDocEventosComponent(false);
        setShowApiDocAlertasComponent(false);
        setShowApiDocHuracanesComponent(false);
        break;
      case 'Noticias':
        setShowApiDocIntroComponent(false);
        setShowApiDocServiciosComponent(false);
        setShowApiDocPronComponent(false);
        setShowApiDocImgComponent(false);
        // setShowApiDocTrabajadoresComponent(false);
        setShowApiDocProyectosComponent(false);
        setShowApiDocNoticiasComponent(true);
        setShowApiDocEventosComponent(false);
        setShowApiDocAlertasComponent(false);
        setShowApiDocHuracanesComponent(false);
        break;
      case 'Eventos':
        setShowApiDocIntroComponent(false);
        setShowApiDocServiciosComponent(false);
        setShowApiDocPronComponent(false);
        setShowApiDocImgComponent(false);
        // setShowApiDocTrabajadoresComponent(false);
        setShowApiDocProyectosComponent(false);
        setShowApiDocNoticiasComponent(false);
        setShowApiDocEventosComponent(true);
        setShowApiDocAlertasComponent(false);
        setShowApiDocHuracanesComponent(false);
        break;
      case 'Alertas':
        setShowApiDocIntroComponent(false);
        setShowApiDocServiciosComponent(false);
        setShowApiDocPronComponent(false);
        setShowApiDocImgComponent(false);
        // setShowApiDocTrabajadoresComponent(false);
        setShowApiDocProyectosComponent(false);
        setShowApiDocNoticiasComponent(false);
        setShowApiDocEventosComponent(false);
        setShowApiDocAlertasComponent(true);
        setShowApiDocHuracanesComponent(false);
        break;
      case 'Ciclones':
        setShowApiDocIntroComponent(false);
        setShowApiDocServiciosComponent(false);
        setShowApiDocPronComponent(false);
        setShowApiDocImgComponent(false);
        // setShowApiDocTrabajadoresComponent(false);
        setShowApiDocProyectosComponent(false);
        setShowApiDocNoticiasComponent(false);
        setShowApiDocEventosComponent(false);
        setShowApiDocAlertasComponent(false);
        setShowApiDocHuracanesComponent(true);
        break;

      default:
        break;
    }
  }

  const apiDocIndex = [
    'Servicios', 'Pronósticos', 'Imágenes',
    /* 'Trabajadores', */ 'Proyectos', 'Noticias',
    'Eventos', 'Alertas', 'Ciclones'
  ];

  return (
    <div /* className={classes.root} */>

      {useMediaQuery("(min-width: 1375px)") &&
        <Drawer
          // className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="right"
        // open={true}
        // onOpen={() => setOpenDrawer(true)}
        // onClose={() => setOpenDrawer(false)}
        >
          <div className={classes.toolbar}>
            <Typography variant="h5" color="textSecondary" align="center" id="toolbarText" style={{ color: 'transparent' }}>
              Contenido
            </Typography>
          </div>
          <List>
            {apiDocIndex.map((text, index) => (
              <ListItem button key={text} onClick={(event) => setVisible(event, text)}>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>
        </Drawer>
      }

      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Container maxWidth="md">
          <Typography variant="h5" color="textPrimary" align="center">
            Documentación de la API
          </Typography>
          <Typography variant="subtitle1" color="textSecondary" align="center">
            Meteorología Santiago de Cuba
          </Typography>

          {showApiDocIntroComponent && <ApiDocIntro />}
          {showApiDocServiciosComponent && <ApiDocServicios />}
          {showApiDocPronComponent && <ApiDocPron />}
          {showApiDocImgComponent && <ApiDocImg />}
          {/* {showApiDocTrabajadoresComponent && <ApiDocTrabajadores />} */}
          {showApiDocProyectosComponent && <ApiDocProyectos />}
          {showApiDocNoticiasComponent && <ApiDocNoticias />}
          {showApiDocEventosComponent && <ApiDocEventos />}
          {showApiDocAlertasComponent && <ApiDocAlertas />}
          {showApiDocHuracanesComponent && <ApiDocHuracanes />}


          {useMediaQuery("(max-width: 1374px)") &&
            <>
              <ApiDocIntro />
              <Divider className={classes.divider} />
              <ApiDocServicios />
              <Divider className={classes.divider} />
              <ApiDocPron />
              <Divider className={classes.divider} />
              <ApiDocImg />
              <Divider className={classes.divider} />
              <ApiDocProyectos />
              <Divider className={classes.divider} />
              <ApiDocNoticias />
              <Divider className={classes.divider} />
              <ApiDocEventos />
              <Divider className={classes.divider} />
              <ApiDocAlertas />
              <Divider className={classes.divider} />
              <ApiDocHuracanes />
            </>
          }

        </Container>
      </main>
    </div>
  );
}